import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../../components/text/text';
// styles
import { AdditionalInfoWrapperStyled, TitleAndAdditionalInfoWrapperStyled, TitleWrapperStyled, } from '../input.styled';
import { InputTitleComponentType } from '../types/titleComponent';
export const TitleStandAlone = (props) => {
    if (!props.title?.content) {
        return null;
    }
    return (_jsxs(TitleAndAdditionalInfoWrapperStyled, { styles: props.styles, children: [_jsx(TitleWrapperStyled, { "$titleStyles": props.styles, as: Text, customTypography: props.styles?.title, ...props.title, component: (props.title.component
                    ? props.title.component
                    : InputTitleComponentType.PARAGRAPH), children: props.title.content }), _jsx(AdditionalInfoWrapperStyled, { styles: props.styles, children: props.additionalInfo })] }));
};
//# sourceMappingURL=title.js.map